import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Stack, Drawer, Paper } from '@mui/material';
import palette from '@theme/palette';
import { useFile } from '@entities/solution';
import { ProjectTabs } from './ProjectTabs/ProjectTabs';
import { ProjectHeader } from './ProjectHeader';
export function ControlMenu() {
    const { id: fileId } = useParams();
    const { data: file } = useFile(fileId);
    if (!file) {
        return null;
    }
    return (_jsx(Stack, { width: 480, borderRight: 1, borderColor: palette.neutral[80], children: _jsx(Drawer, { variant: "permanent", sx: {
                '& .MuiPaper-root': {
                    boxShadow: 'none'
                },
                '& .MuiDrawer-paper': {
                    position: 'relative',
                    width: '100%',
                    height: 'calc(100vh - 80px)'
                }
            }, ModalProps: {
                keepMounted: true
            }, children: _jsxs(Paper, { sx: { width: '100%', display: 'flex', flexDirection: 'column', maxHeight: '100vh' }, children: [_jsx(ProjectHeader, { data: file }), _jsx(ProjectTabs, {})] }) }) }));
}
